// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__QpNBH","additionalInfo":"AgreementModal_additionalInfo__1mcQB"};